import React from "react";

const PrefixContext = React.createContext({});

export const PrefixProvider = PrefixContext.Provider;
export const PrefixConsumer = PrefixContext.Consumer;

export default PrefixContext;
